/**
 * Alpha DNA vault: the shared warehouse (warehouse.ts) with the ID card as its
 * hero (cardHero.ts). Kept as the page's single entry point.
 */
import { createCardHero } from './cardHero';
import { DEFAULT_CONFIG } from './cardDesign';
import { createWarehouse } from './warehouse';

export function createVault(container, cb, opts = {}) {
  let hero = null;
  let pending = null;
  const warehouse = createWarehouse(container, cb, {
    reducedMotion: opts.reducedMotion,
    anchorEl: opts.anchorEl,
    // dark and crisp: no light curtains, a lower exposure, barely any grain
    curtains: false,
    exposure: 1.0,
    grain: 0.006,
    lens: 0, // no colour fringing: the thin light lines stay sharp
    hero: async (ctx) => {
      const first = pending ?? opts.initialConfig ?? DEFAULT_CONFIG;
      hero = await createCardHero(ctx, first);
      if (pending && pending !== first) hero.setConfig(pending); // edited while the card was being drawn
      return hero;
    },
  });
  return {
    start: warehouse.start,
    setCardConfig(cfg) {
      pending = cfg;
      hero?.setConfig(cfg);
    },
    setCustomizing: warehouse.setFocus,
    dispose: warehouse.dispose,
  };
}
